import React from 'react';

const QCElement = ({
    specId = '',
    recId = ''
}) => {
    return (
        <div style={{ border: '1px solid #9c9c9c', borderRadius: 10, padding: 10 }}>
            <p style={{ color: 'white' }}>SpecId: {specId}</p>
            <p style={{ color: 'white' }}>RECID: {recId}</p>
        </div>
    )
};

export default QCElement;